import * as React from 'react';
import { DisplayDate } from '@tock/time';
import { DisplayMoney } from '@tock/money';
import { Typography } from 'omakase';
import { core } from '@tock/coretypes';

interface Props {
  purchase: core.PastPurchase;
}

const TransactionDetails: React.FunctionComponent<Props> = ({ purchase }) => {
  return (
    <>
      {purchase.paymentTransaction.length > 0 ? (
        <div className="Receipt-creditCard">
          {purchase.paymentTransaction.map((transaction) => {
            return (
              <Typography
                variant={transaction.transactionType === 'PAID' ? 'body02Strong' : 'body02'}
              >
                {transaction.transactionType === 'PAID' ? (
                  <>Paid with {purchase.usedChasePay && <>Chase Pay&reg; </>}</>
                ) : null}
                {transaction.transactionType === 'REFUNDED' ? <>Refunded </> : null}
                {transaction.brand} {transaction.maskedNumber}
                {transaction.transactionType === 'PAID' &&
                  transaction.usedApplePay &&
                  transaction.brand !== 'Tock gift card' &&
                  ' (Apple Pay)'}
                <div className="transaction-amount">
                  <DisplayMoney amount={transaction.amountCents} />
                </div>{' '}
                {transaction.date && (
                  <>
                    <br />
                    <div data-testid="receipt-paid-date">
                      <DisplayDate
                        dateValue={transaction.date}
                        displayMonthAs="short"
                        showWeekday={false}
                      />
                    </div>
                  </>
                )}
              </Typography>
            );
          })}
          {purchase.statementDescriptor && (
            <span className="Receipt-statementDescriptor">
              <Typography variant="caption">
                On your statement, this charge will appear as "{purchase.statementDescriptor}"
              </Typography>
            </span>
          )}
          {purchase.loyaltyProgramCardNumber &&
            purchase.canAccrueLoyaltyProgramPoints &&
            purchase.loyaltyProgramPointAccrualCents > 0 && (
              <span className="Receipt-statementDescriptor">
                <Typography variant="caption">
                  Rewards Dollars will be earned on your Rewards Card ending in{' '}
                  {purchase.loyaltyProgramCardNumber.substring(
                    purchase.loyaltyProgramCardNumber.length - 4
                  )}
                </Typography>
              </span>
            )}
        </div>
      ) : null}
    </>
  );
};

export default TransactionDetails;
